{{#if (and (and (not isMonitor) interface.hasResetAndOtherPorts) ports.length)}}
virtual task initialize_signals();
{{#each ports}}
  {{ ../clockingBlock.name }}.{{ identifier }}{{ identifierSpacing }}<= {{ defaultValue }};
{{/each}}
endtask
{{/if}}
